import React, { Component, PureComponent } from 'react'
import { Map, List, fromJS } from 'immutable'
import Card, { CardList } from '~/common/card'

export default function Notes({ project = Map() }) {
  return (
    <Card title="Muistiinpanot" icon="file alternate outline" classTag="notes">
      <CardList
        items={[
          {
            label: 'Myyjän huomiot',
            value: project.getIn(['data', 'customerWishes'], ''),
          },
          {
            label: 'Sisältötoiveet',
            value: project.getIn(['data', 'contentWishes'], ''),
          },
          {
            label: 'Muistiinpanot',
            value: project.getIn(['data', 'notes'], ''),
          },
        ]}
      />
    </Card>
  )
}
